import { render } from "./InspectionDetail.vue?vue&type=template&id=5d5f009f"
import script from "./InspectionDetail.vue?vue&type=script&lang=js"
export * from "./InspectionDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/InspectionDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d5f009f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d5f009f', __exports__)) {
    api.reload('5d5f009f', __exports__)
  }
  
  module.hot.accept("./InspectionDetail.vue?vue&type=template&id=5d5f009f", () => {
    api.rerender('5d5f009f', render)
  })

}


export default __exports__